
(() => {

  /* ==================================================
     DAWN CART DRAWER REFRESH (AS REQUESTED)
  ================================================== */
  async function refreshCartDrawer() {
    const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const data = await res.json();
    const parser = new DOMParser();

    const drawer = parser
      .parseFromString(data['cart-drawer'], 'text/html')
      .querySelector('cart-drawer');

    const bubble = parser
      .parseFromString(data['cart-icon-bubble'], 'text/html')
      .querySelector('#cart-icon-bubble');

    if (drawer) document.querySelector('cart-drawer')?.replaceWith(drawer);
    if (bubble) document.querySelector('#cart-icon-bubble')?.replaceWith(bubble);

    document.querySelector('cart-drawer')?.open();
    function initializeCartDrawerSlider() {
              $('.cart-drawer__collection').slick({
                slidesToShow: 2.5,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: false,
                autoplay: false,
                centerMode: false,
                centerPadding: '0px'
              });
            }
            
            initializeCartDrawerSlider();
  }

  /* ==================================================
     PARSE VARIANT MAP
  ================================================== */
  function getVariants(group) {
    const el = group.querySelector('.rpvs-variant-map');
    if (!el) return [];

    return el.value
      .split('||')
      .filter(Boolean)
      .map(row => {
        const [id, color, size, image, available] = row.split('::');
        return {
          id,
          color,
          size,
          image,
          available: available === 'true'
        };
      });
  }

  /* ==================================================
     COLOR CLICK
     → image change
     → size availability
  ================================================== */
  document.addEventListener('click', e => {
    if (!e.target.classList.contains('rpvs-color-btn')) return;

    const group = e.target.closest('.rpvs__item-group');
    if (!group) return;

    const color = e.target.dataset.color;
    const variants = getVariants(group);

    /* active state */
    group.querySelectorAll('.rpvs-color-btn')
      .forEach(b => b.classList.remove('active'));
    e.target.classList.add('active');

    group.dataset.color = color;

    /* size availability */
    group.querySelectorAll('.rpvs-size-btn').forEach(btn => {
      const size = btn.dataset.size;
      const match = variants.find(v => v.color === color && v.size === size);

      if (!match || !match.available) {
        btn.disabled = true;
        btn.classList.add('unavailable');
      } else {
        btn.disabled = false;
        btn.classList.remove('unavailable');
      }
    });

    /* image change on color */
    const firstAvailable = variants.find(v => v.color === color && v.available);
    if (firstAvailable) {
      const img = group.querySelector('.rpvs-main-image');
      if (img && firstAvailable.image) {
        img.src = firstAvailable.image;
      }
    }
  });

  /* ==================================================
     OPEN SIZE LIST
  ================================================== */
  document.addEventListener('click', e => {
    if (!e.target.classList.contains('rpvs__select-size')) return;

    const group = e.target.closest('.rpvs__item-group');
    if (!group) return;

    if (!group.dataset.color) {
      alert('Please select color first');
      return;
    }

    e.target.style.display = 'none';
    const wrap = group.querySelector('.rpvs-size-wrap');
    if (wrap) wrap.style.display = 'block';
  });

  /* ==================================================
     SIZE CLICK → ADD TO CART
     → CART DRAWER REFRESH
  ================================================== */
  document.addEventListener('click', async e => {
    if (!e.target.classList.contains('rpvs-size-btn')) return;
    if (e.target.disabled) return;

    const group = e.target.closest('.rpvs__item-group');
    if (!group) return;

    const color = group.dataset.color;
    const size = e.target.dataset.size;

    const variant = getVariants(group)
      .find(v => v.color === color && v.size === size && v.available);

    if (!variant) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1
        })
      });

      await refreshCartDrawer();

      /* UI reset */
      const wrap = group.querySelector('.rpvs-size-wrap');
      const btn = group.querySelector('.rpvs__select-size');
      if (wrap) wrap.style.display = 'none';
      if (btn) btn.style.display = 'block';

    } catch (err) {
      console.error('Add to cart failed:', err);
    }
  });

  /* ==================================================
     SLICK SLIDER INIT (2 ITEMS)
  ================================================== */
  function initRpvsSlider() {
    const slider = document.querySelector('.rpvs-slider');
    if (!slider) return;
    if (slider.classList.contains('slick-initialized')) return;

    if (typeof $ === 'undefined' || !$.fn.slick) {
      console.warn('Slick not loaded');
      return;
    }

    $(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots:true,
      infinite: true,
      adaptiveHeight: true
    
    });
  }

  /* INIT ON LOAD */
  document.addEventListener('DOMContentLoaded', initRpvsSlider);
  window.addEventListener('load', initRpvsSlider);

})();

